// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.party-works-table .card-results-table-two {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Search/SearchByParty/PartyWorksTable/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ","sourcesContent":[".party-works-table {\n  .card-results-table-two {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
